import request from '@/util/request'

export function getDictApi(type) {
    return request({
        url: window.$baseUrl_hehu + '/api/daping/getDictDatalist?dictType=' + type,
        method: 'GET',
    })
}